//Modal.js
import React, { useEffect, useState ,useRef } from "react";
import ReactDom from "react-dom"; 
//import 'bootstrap/dist/css/bootstrap.css';
import { Col, Row } from "reactstrap";  
//import ProjectTables from "../components/dashboard/ProjectTable";
import {Modal, Button, Table} from 'react-bootstrap';
import './ModalStyles.css';
import {API_URL} from '../Constants'
import { Dimmer, Loader } from "semantic-ui-react";
import SimpleSubscribeNewsletter from 'components/forms/SimpleSubscribeNewsletter';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
//  import {
//   MDBCarousel,
//   MDBCarouselInner,
//   MDBCarouselItem,
//   MDBView,
//   MDBContainer
// } from 'mdbreact'

export const CompsModal = ({ setShowCompsModal, gems }) => {
  // close the modal when clicking outside the modal.
 // const [zpid] = React.useState(String(route.route.params.zpid));
 const chartDataArray = [];
 const labelsArray = [];
  const [isLoading, setLoading] = useState(true);
  const [loadOnce,setLoadOnce] = useState(0); 
  const [compsData, setCompsData] = useState([]);
  const [active , setActive]  = useState(true);
  const count =0 ; 
  const modalRef = useRef();  
  const closeModal = (e) => {
    setShowCompsModal(false);
  };
 
const handleClose = () => setShowCompsModal(false);
const handleShow = () => setShowCompsModal(true);

  useEffect(() => {
    //const encodedValue = encodeURIComponent(zpid);
    fetch(API_URL +  '/LoadData/getPropertyComps?zpid=' + gems.zpid  )
    .then((response) => response.json())
    .then((json) => setCompsData(json.comps) )
    .catch((error) => console.error(error))
    .finally(() => setLoading(false));
    
    setLoadOnce(loadOnce +  1)
    
    
    
}, []);
 
// if (comp.length != labelsArray.length){
//     taxData.map((taxinfo, index) => {
//         console.log(taxinfo.price)
//         //if(priceinfo.priceChangeRate>0)
//         //{
//             labelsArray.push(taxinfo.convertedTime.slice(0, -10));
//             chartDataArray.push(taxinfo.taxPaid);
    
//         //}
//     });
// }
 //<TaxChart data={chartDataArray} labels={labelsArray} />
  //render the modal JSX in the portal div.

  const addDefaultSrc= (ev) =>{
    ev.target.src = 'data:image/jpeg;base64,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'
  }
  
  return (
    <>
      <div>
 {/* <SimpleSubscribeNewsletter/> */}
 <br></br>

 <p style={{fontStyle: "Bold",fontSize: "25px"}}> Comparison Properties for : {gems.address}</p>
             <br></br>
       <div className='Loader'>
           
           <Loader active = {isLoading} className='workaround' size='large' inline='centered' >Standby...Pulling Comps! This will just take a few seconds to find. </Loader>
       
       </div> 
       {/* <Card style={{ width: '18rem' }}>
      <Card.Header>Comps</Card.Header>
      <ListGroup variant="flush">
        <ListGroup.Item>Cras justo odio</ListGroup.Item>
        <ListGroup.Item>Dapibus ac facilisis in</ListGroup.Item>
        <ListGroup.Item>Vestibulum at eros</ListGroup.Item>
      </ListGroup>
    </Card> */}

            {compsData.map((card, index) => (
            <>
            <table Border='1'> 
            <tr><td><img onError={addDefaultSrc} width='200' height='200' src={card.miniCardPhotos[0].url}  ></img></td>
            <td>
                <table><tr><td><p style={{fontStyle: "Bold",fontSize: "17px"}}>Address: {card.address.streetAddress}, {card.address.city}, {card.address.state}, {card.address.zipcode}</p></td></tr>
                <tr><td><p style={{fontStyle: "Bold",fontSize: "17px"}}>BedRooms: {card.bedrooms}</p></td></tr>
                <tr><td><p style={{fontStyle: "Bold",fontSize: "17px"}}>Baths: {card.bathrooms}</p></td></tr>
                <tr><td><p style={{fontStyle: "Bold",fontSize: "17px"}}>Sqft: {card.livingArea}</p></td></tr>
                <tr><td><p style={{fontStyle: "Bold",fontSize: "17px"}}>Price: {card.price}</p></td></tr>
                </table>
            </td>
            </tr>
            </table>
            </>
             
             ))}

           
            
            </div>
    </>
  );
}
export default CompsModal; 